import { ChangeLogColumns } from "../enum/change-log-columns";

export const changeLogTableColumns = [
    {
        id: ChangeLogColumns.LIST_ID,
        name: "List ID",
        width: 70,
    },
    {
        id: ChangeLogColumns.LIST_NAME,
        name: "List Name",
        width: 150,
    },
    {
        id: ChangeLogColumns.DATE_CHANGED,
        name: "Date Changed",
        width: 70,
    },
    {
        id: ChangeLogColumns.CHANGE_TYPE,
        name: "Change Type",
        width: 70,
    },
    {
        id: ChangeLogColumns.PREVIOUS_VALUE,
        name: "Previous Value",
        width: 70,
    },
    {
        id: ChangeLogColumns.CURRENT_VALUE,
        name: "Current Value",
        width: 70,
    },
];
